import React from 'react';

// Custom SVG icons for spiritual services in orange color
const ORANGE_COLOR = "#f68c3b";

export const SpiritualIcons = {
  // Maha Mrityunjaya / Shiv related - Om symbol with trident
  om: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM12 8C13.7 8 15.2 9.2 15.7 10.8C16.5 10.3 17.5 10.3 18.3 10.8C19.4 11.6 19.6 13.1 18.8 14.2L12 22L5.2 14.2C4.4 13.1 4.6 11.6 5.7 10.8C6.5 10.3 7.5 10.3 8.3 10.8C8.8 9.2 10.3 8 12 8Z" fill={ORANGE_COLOR}/>
    </svg>
  ),

  // Rudrabhishek / Rudra - Trident (Trishul)
  trident: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L11 4V6L12 7L13 6V4L12 2ZM9 6V8L10 9V15L9 16V18L10 19H14L15 18V16L14 15V9L15 8V6L14 5H10L9 6ZM7 8V10L8 11V13L7 14V16L8 17H9V15H8V13H9V11H8V9H7V8ZM17 8V9H16V11H17V13H16V15H17V17H16L15 16V14L16 13V11L17 10V8ZM11 9H13V15H11V9ZM12 18V22H12Z" fill={ORANGE_COLOR}/>
    </svg>
  ),

  // Hanuman - Stylized monkey face
  hanuman: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="10" r="8" fill={ORANGE_COLOR} opacity="0.2"/>
      <path d="M12 4C8.7 4 6 6.7 6 10C6 11.2 6.3 12.3 6.8 13.3L7.5 14.5C8.2 15.7 9.3 16.5 10.5 17H13.5C14.7 16.5 15.8 15.7 16.5 14.5L17.2 13.3C17.7 12.3 18 11.2 18 10C18 6.7 15.3 4 12 4ZM9 9C9.6 9 10 9.4 10 10S9.6 11 9 11S8 10.6 8 10S8.4 9 9 9ZM15 9C15.6 9 16 9.4 16 10S15.6 11 15 11S14 10.6 14 10S14.4 9 15 9ZM12 13.5C11.2 13.5 10.5 14.2 10.5 15H13.5C13.5 14.2 12.8 13.5 12 13.5Z" fill={ORANGE_COLOR}/>
      <path d="M10 19V21C10 21.6 10.4 22 11 22H13C13.6 22 14 21.6 14 21V19H10Z" fill={ORANGE_COLOR}/>
    </svg>
  ),

  // Ganesha - Elephant head
  ganesha: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3C15.3 3 18 5.7 18 9V11C18 14.3 15.3 17 12 17S6 14.3 6 11V9C6 5.7 8.7 3 12 3Z" fill={ORANGE_COLOR} opacity="0.2"/>
      <path d="M12 4C14.8 4 17 6.2 17 9V11C17 13.8 14.8 16 12 16S7 13.8 7 11V9C7 6.2 9.2 4 12 4ZM9.5 8.5C9.2 8.5 9 8.7 9 9S9.2 9.5 9.5 9.5S10 9.3 10 9S9.8 8.5 9.5 8.5ZM14.5 8.5C14.2 8.5 14 8.7 14 9S14.2 9.5 14.5 9.5S15 9.3 15 9S14.8 8.5 14.5 8.5Z" fill={ORANGE_COLOR}/>
      <path d="M5 10C4.4 10 4 10.4 4 11C4 11.6 4.4 12 5 12C5.6 12 6 11.6 6 11C6 10.4 5.6 10 5 10ZM19 10C18.4 10 18 10.4 18 11C18 11.6 18.4 12 19 12C19.6 12 20 11.6 20 11C20 10.4 19.6 10 19 10Z" fill={ORANGE_COLOR}/>
      <path d="M12 11C11.4 11 11 11.4 11 12V14C11 14.6 11.4 15 12 15S13 14.6 13 14V12C13 11.4 12.6 11 12 11Z" fill={ORANGE_COLOR}/>
      <path d="M10 17V20C10 20.6 10.4 21 11 21H13C13.6 21 14 20.6 14 21V17H10Z" fill={ORANGE_COLOR}/>
    </svg>
  ),

  // Vishnu - Lotus flower
  lotus: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4C10 4 8.5 5.5 8.5 7.5C8.5 9.5 10 11 12 11S15.5 9.5 15.5 7.5C15.5 5.5 14 4 12 4Z" fill={ORANGE_COLOR} opacity="0.3"/>
      <path d="M6 8C5 8 4 9 4 10S5 12 6 12C7 12 8 11 8 10S7 8 6 8ZM18 8C17 8 16 9 16 10S17 12 18 12C19 12 20 11 20 10S19 8 18 8Z" fill={ORANGE_COLOR} opacity="0.3"/>
      <path d="M12 10C13.7 10 15.5 11.8 15.5 14S13.7 18 12 18S8.5 16.2 8.5 14S10.3 10 12 10Z" fill={ORANGE_COLOR}/>
      <path d="M12 2L11 6L12 8L13 6L12 2ZM6 6L8 9L10 8L8 5L6 6ZM18 6L16 5L14 8L16 9L18 6ZM4 14L8 13L9 15L5 16L4 14ZM20 14L19 16L15 15L16 13L20 14ZM12 20L13 22L12 20L11 22L12 20Z" fill={ORANGE_COLOR}/>
    </svg>
  ),

  // Lakshmi - Wealth/coin symbol
  wealth: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" fill={ORANGE_COLOR} opacity="0.2"/>
      <path d="M12 3C16.4 3 20 6.6 20 11S16.4 19 12 19S4 15.4 4 11S7.6 3 12 3ZM12 5C8.7 5 6 7.7 6 11S8.7 17 12 17S18 14.3 18 11S15.3 5 12 5Z" fill={ORANGE_COLOR}/>
      <path d="M12 7C13.7 7 15 8.3 15 10C15 10.8 14.6 11.5 14 12C14.6 12.5 15 13.2 15 14C15 15.7 13.7 17 12 17S9 15.7 9 14C9 13.2 9.4 12.5 10 12C9.4 11.5 9 10.8 9 10C9 8.3 10.3 7 12 7ZM12 8.5C11.2 8.5 10.5 9.2 10.5 10S11.2 11.5 12 11.5S13.5 10.8 13.5 10S12.8 8.5 12 8.5ZM12 12.5C11.2 12.5 10.5 13.2 10.5 14S11.2 15.5 12 15.5S13.5 14.8 13.5 14S12.8 12.5 12 12.5Z" fill={ORANGE_COLOR}/>
    </svg>
  ),

  // Navgraha - Nine planets/stars
  planets: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="8" r="2" fill={ORANGE_COLOR}/>
      <circle cx="8" cy="10" r="1.5" fill={ORANGE_COLOR} opacity="0.8"/>
      <circle cx="16" cy="10" r="1.5" fill={ORANGE_COLOR} opacity="0.8"/>
      <circle cx="6" cy="14" r="1.2" fill={ORANGE_COLOR} opacity="0.6"/>
      <circle cx="12" cy="14" r="1.8" fill={ORANGE_COLOR} opacity="0.9"/>
      <circle cx="18" cy="14" r="1.2" fill={ORANGE_COLOR} opacity="0.6"/>
      <circle cx="8" cy="18" r="1" fill={ORANGE_COLOR} opacity="0.5"/>
      <circle cx="12" cy="19" r="1.3" fill={ORANGE_COLOR} opacity="0.7"/>
      <circle cx="16" cy="18" r="1" fill={ORANGE_COLOR} opacity="0.5"/>
    </svg>
  ),

  // Spiritual Consultation - Crystal ball/divine eye
  consultation: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="10" r="8" fill={ORANGE_COLOR} opacity="0.1"/>
      <path d="M12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z" fill={ORANGE_COLOR}/>
      <circle cx="12" cy="12" r="3" fill={ORANGE_COLOR} opacity="0.3"/>
      <circle cx="12" cy="12" r="1.5" fill={ORANGE_COLOR}/>
      <path d="M12 2L13 4L12 5L11 4L12 2ZM2 12L4 11L5 12L4 13L2 12ZM22 12L20 13L19 12L20 11L22 12ZM12 22L11 20L12 19L13 20L12 22Z" fill={ORANGE_COLOR} opacity="0.7"/>
    </svg>
  ),

  // Default spiritual icon - Prayer hands/namaste
  prayer: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L11.5 8L12 12L12.5 8L12 2Z" fill={ORANGE_COLOR}/>
      <path d="M9 4L8 8L9.5 12L12 10L11 6L9 4ZM15 4L13 6L12 10L14.5 12L16 8L15 4Z" fill={ORANGE_COLOR}/>
      <path d="M8 12L9.5 14L12 16L14.5 14L16 12L14.5 18L12 22L9.5 18L8 12Z" fill={ORANGE_COLOR}/>
      <circle cx="12" cy="16" r="1" fill={ORANGE_COLOR} opacity="0.5"/>
    </svg>
  )
};

// Function to get icon component based on service name
export const getSpiritualIcon = (serviceName: string): React.ReactElement => {
  const name = serviceName.toLowerCase();
  
  if (name.includes('mrityunjaya') || name.includes('shiv')) {
    return <SpiritualIcons.om />;
  }
  if (name.includes('rudrabhishek') || name.includes('rudra') || name.includes('anushthaan')) {
    return <SpiritualIcons.trident />;
  }
  if (name.includes('hanuman') || name.includes('chalisa')) {
    return <SpiritualIcons.hanuman />;
  }
  if (name.includes('ganesh') || name.includes('ganesha')) {
    return <SpiritualIcons.ganesha />;
  }
  if (name.includes('vishnu') || name.includes('sahasranama')) {
    return <SpiritualIcons.lotus />;
  }
  if (name.includes('lakshmi')) {
    return <SpiritualIcons.wealth />;
  }
  if (name.includes('navgraha')) {
    return <SpiritualIcons.planets />;
  }
  if (name.includes('spiritual') || name.includes('consultation')) {
    return <SpiritualIcons.consultation />;
  }
  
  // Default icon for other services
  return <SpiritualIcons.prayer />;
};

export default getSpiritualIcon;